import Typography from "@material-ui/core/Typography";
import React from "react";
import Box from "@material-ui/core/Box";
import teamStyles from "../styles/Team.styles";
import TeamLogo from "./TeamLogo";

const Team = ({ team, textVariant }) => {
	const classes = teamStyles();

	const { teamName } = team;

	return (
		<Box display="flex" alignItems="center">
			<TeamLogo hideName team={team} />
			<Typography variant={textVariant} className={classes.teamName}>
				{teamName}
			</Typography>
		</Box>
	);
};

export default Team;
